"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectUserAgent = void 0;
var UserAgents_1 = require("../constants/UserAgents");
var detectUserAgent = function () {
    // The order matters here, and this may report false positives for unlisted browsers.
    if (navigator.userAgent.includes(UserAgents_1.USER_AGENTS.MOZILLA_FIREFOX)) {
        return 'Mozilla Firefox';
    }
    else if (navigator.userAgent.includes(UserAgents_1.USER_AGENTS.SAMSUNG_BROWSER)) {
        return 'Samsung Internet';
    }
    else if (navigator.userAgent.includes(UserAgents_1.USER_AGENTS.OPERA) ||
        navigator.userAgent.includes(UserAgents_1.USER_AGENTS.OPR)) {
        return 'Opera';
    }
    else if (navigator.userAgent.includes(UserAgents_1.USER_AGENTS.TRIDENT)) {
        return 'Microsoft Internet Explorer';
    }
    else if (navigator.userAgent.includes(UserAgents_1.USER_AGENTS.EDGE)) {
        return 'Microsoft Edge (Legacy)';
    }
    else if (navigator.userAgent.includes(UserAgents_1.USER_AGENTS.EDG)) {
        return 'Microsoft Edge (Chromium)';
    }
    else if (navigator.userAgent.includes(UserAgents_1.USER_AGENTS.CHROME)) {
        return 'Google Chrome or Chromium';
    }
    else if (navigator.userAgent.includes(UserAgents_1.USER_AGENTS.SAFARI)) {
        return 'Apple Safari';
    }
    else {
        return 'unknown';
    }
};
exports.detectUserAgent = detectUserAgent;
